/**Auth actions */
export const LOGIN = "LOGIN";


/**Dashboard Actions */
export const DASHBOARD = "DASHBOARD"
export const DASHBOARD_MONTHLY_SALES = "DASHBOARD_MONTHLY_SALES";
export const DASHBOARD_OUTOFSTOCK_PRODUCTS = "DASHBOARD_OUTOFSTOCK_PRODUCTS";
export const DASHBOARD_LOW_STOCK_PRODUCTS = "DASHBOARD_LOW_STOCK_PRODUCTS"


/**Category Actions */
export const CREATE_CATEGORY = "CREATE_CATEGORY"
export const EDIT_CATEGORY = "EDIT_CATEGORY"
export const DELETE_CATEGORY = "DELETE_CATEGORY"
export const VIEW_CATEGORY = "VIEW_CATEGORY"
export const LIST_CATEGORY = "LIST_CATEGORY"

/**Store Actions */
export const CREATE_STORE = "CREATE_STORE"
export const EDIT_STORE = "EDIT_STORE"
export const VIEW_STORE = "VIEW_STORE"
export const LIST_STORE = "LIST_STORE"
export const UPLOAD_STORE_IMAGE = "UPLOAD_STORE_IMAGE"
export const EXPORT_STORES = "EXPORT_STORES"


/**Product Actions */
export const CREATE_PRODUCT = "CREATE_PRODUCT"
export const EDIT_PRODUCT = "EDIT_PRODUCT"
export const DELETE_PRODUCT = "DELETE_PRODUCT"
export const VIEW_PRODUCT = "VIEW_PRODUCT"
export const LIST_PRODUCT = "LIST_PRODUCT"
export const UPLOAD_PRODUCT_IMAGE = "UPLOAD_PRODUCT_IMAGE"
export const CATEGORY_DROPDOWN = "CATEGORY_DROPDOWN"

/**Inventory Actions */
export const INVENTORY_LIST = "INVENTORY_LIST"
export const NEW_STOCKS_LIST = "NEW_STOCKS_LIST"
export const ADD_STOCK = "ADD_STOCK"
export const REMOVE_STOCK = "REMOVE_STOCK"
export const UPDATE_INVENTORY = "UPDATE_INVENTORY"
export const PRODUCTS_DROPDOWN = "PRODUCTS_DROPDOWN"
export const EDIT_INVENTORY = "EDIT_INVENTORY"
export const DELETE_INVENTORY = "DELETE_INVENTORY"
export const STOCKS_REPORT = "STOCKS_REPORT"

export const NEW_STOCKS_RETURN_LIST = "NEW_STOCKS_RETURN_LIST"
export const ADD_STOCK_RETURN = "ADD_STOCK_RETURN"
export const REMOVE_STOCK_RETURN = "REMOVE_STOCK_RETURN"
export const UPDATE_STOCK_RETURN = "UPDATE_STOCK_RETURN"
export const ROUTES_DROPDOWN = "ROUTES_DROPDOWN"
export const CUSTOMERS_DROPDOWN = "CUSTOMERS_DROPDOWN"
export const PURCHASED_PRODUCTS_DROPDOWN = "PURCHASED_PRODUCTS_DROPDOWN"

/**Route Actions */
export const CREATE_ROUTE = "CREATE_ROUTE"
export const EDIT_ROUTE = "EDIT_ROUTE"
export const VIEW_ROUTE = "VIEW_ROUTE"
export const LIST_ROUTE = "LIST_ROUTE"
export const PRODUCT_ROUTE_LIST = "PRODUCT_ROUTE_LIST"
export const COMPLETE_ROUTE = "COMPLETE_ROUTE"
export const DROPERS_DROPDOWN = "DROPERS_DROPDOWN"
export const STORES_DROPDOWN = "STORES_DROPDOWN"

/**Settings Actions */
export const SAVE_SETTINGS = "SAVE_SETTINGS"
export const UPLOAD_LOGO = "UPLOAD_LOGO"
export const RESET_PASSWORD = "RESET_PASSWORD"
export const VIEW_SETTINGS = "VIEW_SETTINGS"


/**Droper Actions */
export const CREATE_DROPER = "CREATE_DROPER"
export const EDIT_DROPER = "EDIT_DROPER"
export const VIEW_DROPER = "VIEW_DROPER"
export const LIST_DROPER = "LIST_DROPER"
export const ENABLE_DISABLE_DROPER = "ENABLE_DISABLE_DROPER"
export const UPLOAD_DROPER_IMAGE = "UPLOAD_DROPER_IMAGE"
export const RESET_PASSWORD_DROPER = "RESET_PASSWORD_DROPER"


/**Order Actions */
export const CREATE_ORDER = "CREATE_ORDER"
export const APPROVE_REJECT_ORDER = "APPROVE_REJECT_ORDER"
export const EDIT_ORDER = "EDIT_ORDER"
export const LIST_ORDER = "LIST_ORDER"
export const VIEW_ORDER = "VIEW_ORDER"

/**Reports Action */
export const INVENTORY_REPORT = "INVENTORY_REPORT"
export const STOCK_IN_REPORT = "STOCK_IN_REPORT"
export const PRODUCT_SALES_REPORT = "PRODUCT_SALES_REPORT"


/**Credits Actions */
export const CREATE_CREDIT = "CREATE_CREDIT";
export const ADD_ROUTE_CREDIT = "ADD_ROUTE_CREDIT";
export const EDIT_ROUTE_CREDIT = "EDIT_ROUTE_CREDIT";
export const LIST_CREDIT = "LIST_CREDIT";
export const VIEW_CREDIT = "VIEW_CREDIT";
export const ROUTES_LIST_CREDIT = "ROUTES_LIST_CREDIT";